let message = null;

export const setMessage = (appMessage) => {
  message = appMessage;
};

export const showMessage = () => {
  if (!message) {
    throw new Error('Message is not initialized.');
  }
  return message;
};
